// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"232":"79c8790d","233":"032d7e8d","449":"0af04f49","587":"409eeade","648":"30d3c3c4"}[chunkId] + ".js";
};